import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BadRequestHandler, GlobalMessageService, HttpResponseStatus } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class CustomBadRequestHandler extends BadRequestHandler {
  responseStatus = HttpResponseStatus.BAD_REQUEST;
  constructor(globalMessageService: GlobalMessageService, private router: Router) {
    super(globalMessageService);
  }

  handleError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    super.handleError(request, response);
    this.handleServerError(request, response);
  }

  protected handleServerError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    const errors = super.getErrors(response);
    if (
      errors?.some((error) => error.type === 'UnknownIdentifierError') &&
      (request.url.includes('/categories/') || request.url.includes('/csshierarchy'))
    ) {
      this.router.navigate(['/not-found']);
    }
  }
}
